import React from "react";
import { SocialAuth } from "./SocialAuth";

interface MastodonProps {
  register: any;
  watch: any;
}

export function Mastodon({ register, watch }: MastodonProps) {
  return (
    <>
      <fieldset className="fieldset bg-base-200 border-base-300 rounded-box border p-4">
        <legend className="fieldset-legend">Mastodon Instance</legend>
        <label className="label">
          <span className="label-text">Instance URL</span>
        </label>
        <input
          placeholder="https://mastodon.social"
          {...register("instance_url", { required: true })}
          className="input w-full"
        />
        <p className="label">
          Enter your Mastodon instance URL (e.g., https://mastodon.social,
          https://fosstodon.org)
        </p>
      </fieldset>
      <SocialAuth
        platform="mastodon"
        title={watch("name") || "Mastodon"}
        showRefreshButton={false}
        instanceUrl={watch("instance_url")}
        postAs={watch("auto_post_as") ? watch("slug") : undefined}
      />
    </>
  );
}
